import { createMemo, For } from "solid-js";
import { useFaqWidget } from "../../../providers/context";
import { Card, CardDescription } from "~/components/ui/card";
import { cn } from "~/util/utils";
import { Group } from "~/components/ui/group";
import { Icon } from "~/components/ui/icon";
import { mdiChevronRight } from "@mdi/js";
import { TranslationField } from "~/components/TranslationField";

export function Bookmarks() {

	const {
		categories,
		bookmark,
		setSelected,
		selected
	} = useFaqWidget();

	const bookmarkedCategories = createMemo(() => {
		const bookmarkedIds = bookmark.bookmarks();
		return categories().map((category) => ({
			...category,
			articles: category.articles.filter((article) => bookmarkedIds.has(article.id))
		})).filter((category) => category.articles.length > 0);
	});

	return (
		<For
			each={bookmarkedCategories()}
		>
			{(category) => (
				<For each={category.articles}>
					{(article) => (
						<Card
							class={cn(
								"w-full transition-all p-4 relative cursor-pointer mb-4",
								"data-[selected='true']:border-l-[5px] data-[selected='true']:border-l-accent",
								"lg:hover:bg-gray-50 lg:active:bg-gray-100"
							)}
							style={{ "border-left-color": selected()?.id === article.id ? category.color : undefined }}
							data-selected={selected()?.id === article.id}
							onClick={() => setSelected(article)}
						>
							<Group>
								<div class="flex-1">
									<CardDescription class="text-gray-600 line-clamp-2 mb-1 text-xs">
										<TranslationField key={category.title} />
									</CardDescription>
									<CardDescription class="text-black line-clamp-2">
										<TranslationField key={article.question} />
									</CardDescription>
								</div>
								<Icon
									class="ml-auto"
									path={mdiChevronRight}
								/>
							</Group>
						</Card>
					)}
				</For>
			)}
		</For>
	);
}